import { io } from "socket.io-client";
import { ws_notify } from "../js/ws_notify";

export const web_socket = {
  methods: {
    connect: function(){
      const ws_funcs = {
        "notify": ws_notify
      };
      for(var namespace in ws_funcs){
        var socket = io(window.location.protocol + "//" + window.location.host + "/" + namespace, {
          transports: ["websocket"],
          path: "/v" + this.$store.getters.api_version + "/api/websocket/socket.io/",
          auth: {
            access_token: this.$store.getters.access_token
          },
          reconnection: false
        });
        var take_over = {
          namespace: namespace,
          socket: socket,
          parent: this
        }
        socket.on('connect', function(){
          // connectではログ取得のみ
          if(this.parent.$store.getters.debug){
            console.log("recv connect");
          }
          this.parent.$store.commit("setWebSocketLog", {
            action: "recv",
            namespace: this.namespace,
            sid: this.socket.id,
            event: "connect",
            message: {},
            date: Math.floor(new Date() / 1000)
          });
        }.bind(take_over));
        socket.on('accepted', function(){
          // acceptedで接続完了とする
          if(this.parent.$store.getters.debug){
            console.log("recv accepted");
          }
          this.parent.$store.commit("setWebSocketLog", {
            action: "recv",
            namespace: this.namespace,
            sid: this.socket.id,
            event: "connect",
            message: {},
            date: Math.floor(new Date() / 1000)
          });
          this.parent.$store.commit("setNotification", {
            type: "success",
            message: {
              eid: "E187011:00000000",
              param: {}
            }
          });
          this.parent.$store.commit("setWebSocket", {
            namespace: this.namespace,
            socket: this.socket
          });
          this.parent.connecting = false;
        }.bind(take_over));
        socket.on('error', function(msg){
          if(this.parent.$store.getters.debug){
            console.log("recv error: " + JSON.stringify(msg));
          }
          this.parent.$store.commit("setWebSocketLog", {
            action: "recv",
            namespace: this.namespace,
            sid: this.socket.id,
            event: "error",
            message: msg,
            date: Math.floor(new Date() / 1000)
          });
          if("eid" in msg){
            this.parent.$store.commit("setNotification", {
              type: "error",
              message: {
                eid: "E187112:00000000",
                param: {
                  message: msg
                }
              }
            });
          }
          this.parent.connecting = false;
        }.bind(take_over));
        socket.on("connect_error", function(err){
          if(this.parent.$store.getters.debug){
            console.error("recv connect_error: " + JSON.stringify(err));
          }
          this.parent.$store.commit("setWebSocketLog", {
            action: "recv",
            namespace: this.namespace,
            sid: this.socket.id,
            event: "connect_error",
            message: err,
            date: Math.floor(new Date() / 1000)
          });
          this.parent.$store.commit("setNotification", {
            type: "warning",
            message: {
              eid: "E187111:00000000",
              param: {}
            }
          });
          if(this.socket.connected){
            this.socket.disconnect();
          }
          this.parent.$store.commit("deleteWebSocket", this.namespace);
          this.parent.connecting = false;
        }.bind(take_over));
        socket.on("disconnect", function(msg){
          if(this.parent.$store.getters.debug){
            console.log("recv disconnect: " + JSON.stringify(msg));
          }
          this.parent.$store.commit("setWebSocketLog", {
            action: "recv",
            namespace: this.namespace,
            sid: this.socket.id,
            event: "disconnect",
            message: msg,
            date: Math.floor(new Date() / 1000)
          });
          if(namespace in this.parent.$store.getters.web_socket){
            this.parent.$store.commit("setNotification", {
              type: "success",
              message: {
                eid: "E187012:00000000",
                param: {}
              }
            });
            this.parent.$store.commit("deleteWebSocket", this.namespace);
          }
        }.bind(take_over));
        for(var event in ws_funcs[namespace]){
          var take_over = {
            namespace: namespace,
            event: event,
            socket: socket,
            ws_func: ws_funcs[namespace][event].bind(this),
            parent: this
          }
          socket.on(event, function(msg){
            if(this.parent.$store.getters.debug){
              console.log("recv " + event + ": " + JSON.stringify(msg));
            }
            this.parent.$store.commit("setWebSocketLog", {
              action: "recv",
              namespace: this.namespace,
              sid: this.socket.id,
              event: this.event,
              message: msg,
              date: Math.floor(new Date() / 1000)
            });
            this.ws_func(msg);
          }.bind(take_over));
        }
      }
    },
    disconnect: function(){
      for(var namespace in this.$store.getters.web_socket){
        this.$store.getters.web_socket[namespace].disconnect();
        this.$store.commit("deleteWebSocket", namespace);
      }
    },
    emit: function(namespace, event, message){
      if(namespace in this.$store.getters.web_socket){
        if(this.parent.$store.getters.debug){
          console.log("emit " + event + ": " + JSON.stringify(msg));
        }
        this.$store.commit("setWebSocketLog", {
          action: "emit",
          namespace: namespace,
          sid: this.$store.getters.web_socket[namespace].id,
          event: event,
          message: message,
          date: Math.floor(new Date() / 1000)
        });
        this.$store.getters.web_socket[namespace].emit(
          event,
          message
        );
      }
    }
  }
}
